/* Global add-to-cart handler with fallback for missing data-variant-id */
(function () {
  function goToCartPreservePreview() {
    var dest = window.Shopify.routes.root + 'cart';
    var params = new URLSearchParams(window.location.search);
    var preview = params.get('preview_theme_id');
    if (preview) dest += '?preview_theme_id=' + encodeURIComponent(preview);
    window.location.href = dest;
  }

  function getVariantIdFromDOM(btn) {
    // 1. Try data attribute on the button
    var raw = btn.dataset.variantId;
    var id = parseInt(raw, 10);
    if (!isNaN(id) && id > 0) return id;

    // 2. Try the product form (most themes)
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) {
      id = parseInt(input.value, 10);
      if (!isNaN(id) && id > 0) return id;
    }

    // 3. Could add more fallbacks here (global JSON, etc)
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-add-to-cart');
    if (!btn) return;

    e.preventDefault();

    var variantId = getVariantIdFromDOM(btn);
    var qty = Number(btn.dataset.quantity || 1);
    if (qty < 1) qty = 1;

    if (!variantId) {
      console.error('add-to-cart-buttons.js: missing variant ID');
      alert('Kan niet toevoegen: variant ontbreekt.');
      return;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { goToCartPreservePreview(); })
      .catch(function (err) {
        console.error('Add to cart error', err);
        alert('Fout bij het toevoegen aan je winkelwagen.');
      });
  });

  /* Optional: sync with variant picker if your theme emits this event
  document.addEventListener('variant:change', function (evt) {
    var v = evt.detail && evt.detail.variant;
    if (!v) return;
    document.querySelectorAll('.js-add-to-cart').forEach(function (b) {
      b.dataset.variantId = v.id;
    });
  });
  */
})();
